<mat-toolbar [ngStyle]="{ 'background-color': headerColor }">
  <div>
    <ul class="carrier-branding">
      <li>
        <a class="carrier-name" routerLink="/home">
          <div class="logo-and-text">
            @if (logoUrl) {
              <img [src]="logoUrl" alt="Logo" class="logo" />
            }
            {{ carrierName }}
          </div>
        </a>
      </li>
    </ul>
  </div>
  @if (showHeaderElements) {
    <div class="navigation-items-container">
      <div class="navigation-item">
        <mat-icon class="aligned-icon">personal_video</mat-icon
          ><button
          class="header-link aligned-text"
          (click)="openDialog()"
          [ngStyle]="{ 'background-color': headerColor }"
          >
          Display Settings
        </button>
      </div>
      @if (canWriteShipperOrganization()) {
        <div class="navigation-item">
          <mat-form-field class="view-as-select" [ngStyle]="{ 'background-color': rgaHeaderColor }">
            <mat-label>View as...</mat-label>
            <mat-select [(ngModel)]="companyId"
                        name="companyId"
                        (ngModelChange)="onShipperChange()">
              @for (shipper of shippers; track shipper) {
              <mat-option [value]="shipper.BillTos">{{ shipper.Name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      <div class="navigation-item">
        <div
          [matMenuTriggerFor]="menu"
          class="circle"
          [ngStyle]="{ 'background-color': circleColor }"
          >
          @if (photoUrl) {
            <img class="circle-image" [src]="photoUrl" />
          }
          @if (showInitials && !photoUrl) {
            <div class="initials">
              {{ initials }}
            </div>
          }
        </div>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="openAccountProfileModal()">
            Profile
          </button>
          <button mat-menu-item (click)="logout()">Logout</button>
        </mat-menu>
      </div>
    </div>
  }
</mat-toolbar>
